import { KEY } from '../../types';

export const GET_RELATIONSHIPS_TO_SUBSCRIBER = `${KEY}.GET_RELATIONSHIPS_TO_SUBSCRIBER`;
export const GET_RELATIONSHIPS_TO_SUBSCRIBER_SUCCESS = `${KEY}.GET_RELATIONSHIPS_TO_SUBSCRIBER_SUCCESS`;
export const GET_RELATIONSHIPS_TO_SUBSCRIBER_FAIL = `${KEY}.GET_RELATIONSHIPS_TO_SUBSCRIBER_FAIL`;

export const getRelationshipsToSubscriber = () => ({
  type: GET_RELATIONSHIPS_TO_SUBSCRIBER,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'getRelationshipsToSubscriber'
    }
  }
});
